import type { LocalisationState } from './types';

const DEFAULT_MAX_VARIANTS = 9;
const DEFAULT_SUFFIX = 'other';

const getTranslatedString = (
  state: LocalisationState,
  stringId?: string | number | null,
  variables?: Record<string, string> | null,
  cardinality?: number,
  maxVariants: number = DEFAULT_MAX_VARIANTS,
  suffix: string = DEFAULT_SUFFIX,
): string => {
  const { translations } = state;
  let stringKey = stringId;

  if (cardinality) {
    stringKey = `${stringId}_${cardinality}`;

    if (
      typeof stringKey !== 'string' ||
      !translations[stringKey] ||
      cardinality > maxVariants
    ) {
      stringKey = `${stringId}_${suffix}`;
    }
  }

  if (typeof stringKey !== 'string' || !translations[stringKey]) {
    return `@@${String(stringKey)}@@`;
  }

  const translatedString = translations[stringKey];

  if (!variables) {
    return translatedString;
  }

  return Object.keys(variables).reduce((accumulator, key) => {
    const value = variables[key];
    return accumulator.replace(new RegExp(`@@${key}@@`, 'g'), value);
  }, translatedString);
};

const getLocalisationVars = (state: LocalisationState) => ({
  market: state.market,
  locale: state.locale,
  currency: state.currency,
});

const getFirstDayOfWeek = (state: LocalisationState) => state.firstDayOfWeek;

export default {
  getTranslatedString,
  getLocalisationVars,
  getFirstDayOfWeek,
};
